
import { defineComponent, ref } from "vue";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ToolTip from "@/components/common/ToolTip.vue";
import routesPath from "@/config/routesPath";
import * as apiClient from "@/apiclient/";
import TokenService from "@/services/tokenService";
import messages from "@/config/messages";
import common from "@/config/common";
import { mapGetters } from "vuex";

interface UserData {
  userName: string;
  password: string;
}

export default defineComponent({
  name: "PandALogin",
  components: {
    ToolTip,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      user: {
        userName: "",
        password: "",
      } as UserData,

      submitted: false,
      isFormInvalid: false,
      validationMsg: "Invalid registration code or SSN. Please try again",
      isSubmitDisabled: false,
      messages,
      loginResponse: {} as apiClient.LoginResponse,
      routesPath,
    };
  },
  validations() {
    return {
      user: {
        userName: {
          ...{
            required,
          },
        },
        password: {
          ...{
            required,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getAutoLogoutMsg"]),
  },
  methods: {
    hideErrors(field: string): void {
      this.v$.user[field].$touch();
      this.isFormInvalid = false;
    },
    buttonDesign(): string {
      const buttonStatus = this.v$.user.$invalid;
      return buttonStatus == true ? "btn-secondary" : "btn-primary";
    },
    async userLoginPandA(): Promise<void> {
      TokenService.logout();

      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      const params = {
        username: this.user.userName,
        password: this.user.password,
      };
      this.isSubmitDisabled = true;
      const result = await apiClient
        .loginController()
        .postApiLoginAuthorize(params);

      this.isSubmitDisabled = false;
      if (!result || result.error) {
        this.isFormInvalid = true;
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
        return;
      } else if (result.data?.valid) {
        if (result.data?.requireMFA) {
          const token: string = result.data?.mfaToken || "";
          TokenService.setToken(common.storageVariables.mfaToken, token);
          this.$router.push({ name: routesPath.mfa });
          return;
        }
        if (result.data?.requireChallenge) {
          const token: string = result.data?.challengeToken || "";
          TokenService.setToken("ChallengeToken", token);
          sessionStorage.setItem(
            common.storageVariables.challengeQuestion,
            result.data!.challengeQuestion!
          );
          this.$router.push({ name: routesPath.challenge });
          return;
        }
        TokenService.logout();
        const token: string = result.data?.participantToken?.token || "";
        const refreshToken: string =
          result.data?.participantToken?.refreshToken || "";
        TokenService.setAccessToken(token);
        TokenService.setRefreshToken(refreshToken);
        this.$router.push({ name: routesPath.enrollments });
        return;
      } else {
        this.isFormInvalid = true;
        const message: string = result.data?.message || "";
        this.validationMsg = message + messages.errorMsg;
        return;
      }
    },
  },
});
